<template>
  <div>
    <vx-card id="loading-block" class="vs-con-loading__container" :collapse-action="true" title="Companies">
      <vs-list
        v-for="(company, index) in companies"
        :index="index"
        :key="company.company_id"
      >
        <vs-list-item :title="company.name">
          <vs-button class="float-right ml-2" type="line" size="small" color="danger" icon="delete" @click="deleteCompany(company.company_id)" />
        </vs-list-item>
      </vs-list>

      <div class="vx-row">
        <div class="vx-col w-full mt-4 mb-2">
          <vs-button class="float-right" color="primary" type="border" icon-after icon="add" @click="showAddNewCompany=true">Add Company</vs-button>
        </div>
      </div>
    </vx-card>

    <add-company-trusted-partner
      :showAddNewCompany.sync="showAddNewCompany"
      :companies.sync="companies"
      :trustedPartnerId="trustedPartnerId"
    />
  </div>
</template>

<script>
  import api from "@/http/api";
  import AddCompanyTrustedPartner from "@/views/content/trusted-partners/AddCompanyTrustedPartner";

  export default {
    components: {
      AddCompanyTrustedPartner
    },
    props: [
      'trustedPartnerId',
      'companies',
    ],
    data() {
      return {
        showAddNewCompany: false
      }
    },
    methods: {
      async deleteCompany(companyId) {
        this.showSpinnerOverCard()
        const success = await api.deleteTrustedPartnerCompany(this.trustedPartnerId, companyId);

        if (success) this.$emit('update:companies', this.companies.filter(c => c.company_id !== companyId));

        this.hideSpinnerOverCard()
        this.$vs.notify({
          title: success ? 'Success' : 'Failed',
          text:  success ? 'Removed Successfully!' : 'Unable to be removed!',
          color: success ? 'success' : 'danger',
          icon:  success ? 'check_circle_outline' : 'error'
        })
      },
      showSpinnerOverCard(){
        this.$vs.loading({
          container: '#loading-block',
          scale: 0.6
        });
      },
      hideSpinnerOverCard() {
        this.$vs.loading.close('#loading-block > .con-vs-loading')
      },
    }
  }
</script>
